import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Checkbox from '@material-ui/core/Checkbox'
import Link from '@material-ui/core/Link'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import LabledValue from './LabeldValue'
import queryString from 'query-string'
import ErrorBoundary from './ErrorBoundary'
import { ReceiveDamagedReasonLabels, ReceiveDamagedReasons } from '../enum'

class StatusLine extends Component {
    static propTypes = {
        line: PropTypes.object.isRequired,
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        setDialogState: PropTypes.func.isRequired
    }

    constructor(props) {
        super(props);

        this.state = {
            line: props.line,
            hasEdits: false,
        }
    }
  
    componentDidMount = () => {
        let params = queryString.parse(this.props.location.search)
        if (params && params.for) {
            if (this.state.line.lineId === Number(params.for)) {
                this.showDeniedImages(this.state.line)
            }
        }
        window.scrollTo(0, 0)
    }

    handleCheckChange = name => event => {
        var nv = event.target.checked
        var cs = this.state
        if (name === "isReturn" && nv) {
            if (cs.line.isExchange === true) {
                cs.line.isExchange = false
                cs.line.isNewEdit = false
            } else {
                cs.line.isNewEdit = true
            }
        }
        if (name === "isExchange" && nv) {
            if (cs.line.isReturn === true) {
                cs.line.isReturn = false
                cs.line.isNewEdit = false
            } else {
                cs.line.isNewEdit = true
            }
        }
        cs.line[name] = event.target.checked
        this.setState({ cs })
        this.persist(cs)
        if (nv && !this.props?.reshipOrder) {
            this.beginEdit(cs.line.uiid)
        }

    };

    handleEditClick = () => {
        this.beginEdit(this.state.line.uiid)
    }


    persist = (newState) => {
        let orderInfo = JSON.parse(localStorage.getItem('orderInfo') || '')
        let indx = orderInfo.lines.findIndex(f => f.uiid === this.state.line.uiid)
        orderInfo.lines[indx] = this.state.line
        localStorage.setItem('orderInfo', JSON.stringify(orderInfo))
    }

    showDeniedImages = (line) => {
        var urls = line.deniedImages
        this.props.setDialogState(
            true,
            'Additional Information about denied return.',
            <div>
                {this.buildDeniedInfo(line.deniedReason)}
                {urls.map((v, i) =>
                    <img src={'https://babotstorage.blob.core.windows.net/receive-damaged-image/' + v}
                        key={i}
                        alt={"denied image number " + i}
                        width={"95%"}
                        style={{ border: '1px solid grey', marginLeft: 2 }}
                    />
                )}
            </div>,
            <></>,
            true,
            true)
    }

    beginEdit = (uiid) => {
        this.props.history.push('/pages/returns/edit?uiid=' + uiid)
    }

    openLink = (url) => {
        window.open(url, "_blank")
    }

    buildDeniedInfo = (reason) => {
        switch (reason) {
            case 'Used/Worn':
                return <p><strong>Used/Worn:</strong> The item was visibly used or worn, beyond just trying on the brace. This could include scuffs or dirt marks, pet hair, body dander, etc. We clean all of the products when they’re returned, and if our standard cleaning procedures cannot return the item to “like new” condition, it will be denied.</p>
            case 'Damaged':
                return <p><strong>Damaged:</strong> The item arrived with damage that was not caused by the shipping process. This could include tears, rips, broken buckles or straps, or any other physical damage that impairs the functionality or appearance of the brace. Items damaged during shipping should be reported to the carrier.</p>;
            case 'Missing Parts/Pieces':
                return <p><strong>Missing Parts/Pieces:</strong> The brace was not returned with all the necessary parts. Some products have extra pads, stockinettes or other accessories that must be returned for a full refund or exchange. If you have the missing pieces and just forgot to send them back, please contact us to let us know you’ll be sending them our way.</p>          
            case 'Not a BraceAbility Product':
                return <p><strong>Not a BraceAbility Product:</strong> The returned item is not a product that BraceAbility sells. This could be due to a mistaken return or an attempt to return a counterfeit product.</p>;
            case 'Item was not Included in Package':
                return <p><strong>Item was not Included in Package:</strong> The item listed on the return request was not found in the returned package. This could be due to an error in packaging or a separate item being mistakenly included in the return.</p>;
            case 'Smoke Smell or Other Odor':
                return <p><strong>Smoke Smell or Other Odor:</strong> Your item was returned with a noticeable odor that prevents it from being considered “like new” condition. This could be smoke smell, pet odor, body odor, etc.</p>
            default:
                break;
        }
    }

    buildStatus = (line) => {
        // eslint-disable-next-line no-script-url
        let hideReturnTrackButton = false;
        let hideExchangeTrackButton = false;
        let deniedLabel = "";
        var status = line.status
        var result = <LabledValue title="Status:" value="unknown" />

        switch (status) {
            case "Pending":
                result = <LabledValue title="Status:" value="Pending - Item has not Shipped" />
                hideReturnTrackButton = true
                break;
            case "TooOld":
                result = <LabledValue title="Status:" color="red" value="Order was created more than 30 days ago!!" />
                hideReturnTrackButton = true
                break;
            case "Completed":
                result = <LabledValue title="Status:" value="Completed" />
                hideReturnTrackButton = true
                break;

            case "Initiated":
                result = <LabledValue title="Status:" value="Initiated" />
                break;

            case "Eligible":
                result = <LabledValue title="Status:" value={"Eligible for Return Until " + new Date(line.eligibleDate).toLocaleDateString()} />
                hideReturnTrackButton = true
                hideExchangeTrackButton=true
                break;

            case "Ineligible":
                result = <LabledValue title="Status:" value={"No longer eligible for return"} />
                hideReturnTrackButton = true
                break;

            case "Refunded":
                //result = <LabledValue title="Status:" value={'Refunded $' + line.refundAmount} />
                result = <LabledValue title="Status:" value={'Refunded'} />
                hideReturnTrackButton = true
                break;

            case "Exchanged":
                result = <LabledValue title="Status:" value="Exchanged" />
                hideReturnTrackButton = true
                break;

            case "Denied":
                deniedLabel = line?.deniedReason === ReceiveDamagedReasons.DENIED_UNENFORCEABLE ? ReceiveDamagedReasonLabels.DENIED_UNENFORCEABLE : `Denied(${line?.deniedReason})`;
                result = <LabledValue 
                            title="Status:" 
                            value={deniedLabel} />
                hideReturnTrackButton = true
                break;

            default:
                break;
        }
        // if()
        // {
        //     hideReturnTrackButton=true;   
        // }
        const slimButtonStyle = {
            marginTop: 5,
            textTransform: "none",
            lineHeight: 1
        }

        return <ErrorBoundary>
            <Grid container direction="column" justify="flex-start" alignItems="flex-start">
                <Grid item>
                    {result}
                </Grid>
                {line.deniedReason ?
                    <Grid item>
                        <Link onClick={() => this.showDeniedImages(line)} variant="body2" >
                            Click to see why your return was denied.
                    </Link>
                    </Grid>
                    : <></>}
                {line.trackingUrl && !line.exchangeTrackingUrl && !hideReturnTrackButton ?
                    <Grid item>
                        <Button style={slimButtonStyle} className="slimButton" color="secondary" variant="outlined" onClick={() => this.openLink(line.trackingUrl)} >
                            Track your Return
                    </Button>
                    </Grid>
                    : <></>}
                {line.shipInstructionsUrl && !line.exchangeTrackingUrl && !hideReturnTrackButton ?
                    <Grid item>
                        <Button style={slimButtonStyle} color="secondary" variant="outlined" onClick={() => this.openLink(line.shipInstructionsUrl)} >
                            Reprint Label/Instructions
                    </Button>
                    </Grid>
                    : <></>}
                {line.exchangeTrackingUrl && !hideExchangeTrackButton ?
                    <Grid item>
                        <Button style={slimButtonStyle} color="secondary" variant="outlined" onClick={() => this.openLink(line.exchangeTrackingUrl)} >
                            Track your Exchange
                        </Button>
                    </Grid>
                    : <></>}
            </Grid>
        </ErrorBoundary>
    }

    buildWarning = (warning) => {
        let warningText = ""
        switch (warning) {
            case "TooOld":
                warningText = "This order is older than our 30-day return policy, so only process a return/exchange if this is a special circumstance."
                break;
            case "FBA":
                warningText = "This is an FBA Order, so only process an exchange if the customer DID NOT initiate a return through Amazon."
                break;
            case "Amazon":
                warningText = "This is an Amazon Order, so only process an exchange if the customer DID NOT initiate a return through Amazon."
                break;
            default:
                break;
        }
        return <Box style={{ border: "1px solid red", padding: 5 }}>
            <p style={{ color: "red" }}><strong>{warningText}</strong></p>
        </Box>
    }

    render() {
        let line = this.state.line
        const canReturn = this.state.line.isEligible
        const hasEdits = this.state.line.hasEdits
        const boxBorderColor = line.warning ? "red" : "lightgrey"
        const reshipReference = ['RETURN/EXCHANGE', 'RESHIP', 'WARRANTY', 'DEFECTIVE/DAMAGED']

        return (
            <Box style={{ border: "1px solid " + boxBorderColor, padding: 5, width: "100%", background: canReturn ? 'white' : '#f1f1f1' }}>
                {line.warning ? this.buildWarning(line.warning) : <></>}
                <Grid container direction="row" justify="flex-start" alignItems="center"   >
                    <Grid item>
                        <Typography variant="subtitle2" display="block" component="div"  >{line.productTitle}</Typography>
                    </Grid>
                </Grid>

                <Grid container direction="column" justify="space-around" alignItems="center">
                    <Grid container direction="row" alignItems="center">
                        {
                            this.props?.reshipOrder && (
                                <Grid item>
                                    <Grid container direction="column" style={{ marginLeft: 10 }}>
                                        <Grid item>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        disabled={reshipReference?.some(titleRef => line?.reference?.includes(titleRef))}
                                                        checked={line.isReship}
                                                        onChange={this.handleCheckChange('isReship')}
                                                        value="isReship"
                                                        color="primary"
                                                    />
                                                }
                                                label="Reship"
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            )
                        }
                        {canReturn && !this.props?.reshipOrder && (
                            <Grid item>
                                <Grid container direction="column" style={{ marginLeft: 10 }}>
                                    <Grid item>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={line.isReturn}
                                                    onChange={this.handleCheckChange('isReturn')}
                                                    value="isReturn"
                                                    color="primary"
                                                />
                                            }
                                            label="Return"
                                        />
                                    </Grid>
                                    {line.canExchange && line.options && (
                                        <Grid item>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={line.isExchange}
                                                        onChange={this.handleCheckChange('isExchange')}
                                                        value="isExchange"
                                                        color="primary"
                                                    />
                                                }
                                                label="Exchange"
                                            />
                                        </Grid>
                                    )
                                }
                                {
                                    hasEdits && (
                                        <Grid item>
                                            <Button color="primary" onClick={this.handleEditClick} variant="contained" style={{ backgroundColor: 'green', marginBottom: 5 }}>Edit</Button>
                                        </Grid>
                                    )
                                }
                                </Grid>
                            </Grid>
                        )}
                        <Grid item>
                            <img
                                style={{ marginRight: 2 }}
                                src={line.productImage.src}
                                alt={line.productImage.alt}
                                width="115"
                            />
                        </Grid>
                        <Grid item>
                            <Grid container direction="column" justify="flex-start" alignItems="flex-start">
                                <LabledValue title="SKU:" value={line.sku} />
                                <LabledValue title="Price:" value={line.price} prefix="$" />
                                {this.buildStatus(line)}
                                <LabledValue title="Reason:" value={line.reason} />
                                <LabledValue title="New Size:" value={line.newSize} />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

            </Box>
        )
    }
}

const StatusLineWithRouter = withRouter(StatusLine)
export default StatusLineWithRouter
